import { createAction } from 'typesafe-actions';
import { ActionTypes, AuthResponse } from '../types';

export const setLoggedUser = createAction(ActionTypes.SET_LOGGED_USER)<AuthResponse>();
export const cleanLoggedUser = createAction(ActionTypes.CLEAN_LOGGED_USER)<void>();
